import React from 'react';

import HandsRaisedIcon from '../assets/hands_raised.svg';
import MapIcon from '../assets/map.svg';

const infoSections = [
  {
    icon: <img src={HandsRaisedIcon} alt="Hands raised in the air" />,
    name: 'Improve Your GRE Score, Guaranteed',
    text: 'Magoosh has official practice questions, full-length practice tests, expert video lessons, custom study schedules and more.'
  },
  {
    icon: <img src={MapIcon} alt="Map showing a path to follow" />,
    name: 'Plus! Grad Admissions Support',
    text: 'Use our application tracker to demystify the process and submit strong Master’s or PhD applications.'
  }
];

export default { infoSections };
